import { useEffect, useState } from 'react';
import clsx from 'clsx';

const ESTADOS_ENVIO = [
  { id: 'carga_origen', label: 'Carga Origen', warning: false },
  { id: 'despacho_foja', label: 'Despacho Foja', warning: false },
  { id: 'recepcion_destino', label: 'Recepción Destino', warning: false },
  { id: 'carga_retenida', label: 'Carga Retenida', warning: true },
  { id: 'entrega_conforme', label: 'Entrega Conforme', warning: false },
  { id: 'cobro_crr', label: 'Cobro de Crr.', warning: false },
];

export default function NotificacionesTab({ data = {}, onChange }) {
  const [aplicarATodos, setAplicarATodos] = useState(data?.aplicarATodos || false);
  const [destinosGenerales, setDestinosGenerales] = useState({
    emails: data?.destinosGenerales?.emails || '',
    whatsapp: data?.destinosGenerales?.whatsapp || '',
  });
  const [noEnviarFueraHorario, setNoEnviarFueraHorario] = useState(
    data?.noEnviarFueraHorario || false
  );
  const [horarioDesde, setHorarioDesde] = useState(data?.horarioDesde || '');
  const [horarioHasta, setHorarioHasta] = useState(data?.horarioHasta || '');

  const [avisosPorEstado, setAvisosPorEstado] = useState(
    data?.avisosPorEstado ||
      ESTADOS_ENVIO.reduce((acc, estado) => {
        acc[estado.id] = {
          email: false,
          whatsapp: false,
          destinoPersonalizado: '',
          whatsappPersonalizado: '',
        };
        return acc;
      }, {})
  );

  useEffect(() => {
    setAplicarATodos(data?.aplicarATodos || false);
    setDestinosGenerales({
      emails: data?.destinosGenerales?.emails || '',
      whatsapp: data?.destinosGenerales?.whatsapp || '',
    });
    setNoEnviarFueraHorario(data?.noEnviarFueraHorario || false);
    setHorarioDesde(data?.horarioDesde || '');
    setHorarioHasta(data?.horarioHasta || '');
    setAvisosPorEstado(
      data?.avisosPorEstado ||
        ESTADOS_ENVIO.reduce((acc, estado) => {
          acc[estado.id] = {
            email: false,
            whatsapp: false,
            destinoPersonalizado: '',
            whatsappPersonalizado: '',
          };
          return acc;
        }, {})
    );
  }, [data]);

  const handleDestinosGeneralesChange = (field, value) => {
    const newDestinos = { ...destinosGenerales, [field]: value };
    setDestinosGenerales(newDestinos);
    onChange?.({
      destinosGenerales: newDestinos,
      avisosPorEstado,
      aplicarATodos,
      noEnviarFueraHorario,
      horarioDesde,
      horarioHasta,
    });
  };

  const handleAvisoChange = (estadoId, field, value) => {
    const newAvisos = {
      ...avisosPorEstado,
      [estadoId]: { ...avisosPorEstado[estadoId], [field]: value },
    };
    setAvisosPorEstado(newAvisos);
    onChange?.({
      destinosGenerales,
      avisosPorEstado: newAvisos,
      aplicarATodos,
      noEnviarFueraHorario,
      horarioDesde,
      horarioHasta,
    });
  };

  const handleAplicarATodosChange = (checked) => {
    setAplicarATodos(checked);
    onChange?.({
      destinosGenerales,
      avisosPorEstado,
      aplicarATodos: checked,
      noEnviarFueraHorario,
      horarioDesde,
      horarioHasta,
    });
  };

  const handleHorarioChange = (field, value) => {
    const setters = {
      horarioDesde: setHorarioDesde,
      horarioHasta: setHorarioHasta,
    };
    setters[field]?.(value);
    onChange?.({
      destinosGenerales,
      avisosPorEstado,
      aplicarATodos,
      noEnviarFueraHorario,
      horarioDesde: field === 'horarioDesde' ? value : horarioDesde,
      horarioHasta: field === 'horarioHasta' ? value : horarioHasta,
    });
  };

  const handleNoEnviarFueraHorario = (checked) => {
    setNoEnviarFueraHorario(checked);
    onChange?.({
      destinosGenerales,
      avisosPorEstado,
      aplicarATodos,
      noEnviarFueraHorario: checked,
      horarioDesde,
      horarioHasta,
    });
  };

  return (
    <div className="space-y-6">
      {/* Destinos Generales */}
      <section className="rounded-xl border border-[rgba(var(--border),0.6)] bg-[rgb(var(--panel))] p-6">
        <h3 className="mb-4 text-base font-semibold text-[rgb(var(--fg))]">
          Destinos Generales de Notificación
        </h3>
        
        <div className="grid gap-4 md:grid-cols-2">
          <div>
            <label
              htmlFor="emails-generales"
              className="mb-1.5 block text-sm font-medium text-[rgb(var(--fg))]"
            >
              Emails
            </label>
            <input
              id="emails-generales"
              type="text"
              value={destinosGenerales.emails}
              onChange={(e) => handleDestinosGeneralesChange('emails', e.target.value)}
              placeholder="cliente@empresa.com, otro@empresa.com"
              className="h-10 w-full rounded-lg border border-[rgba(var(--border),0.6)] bg-[rgb(var(--subpanel))] px-3 text-sm text-[rgb(var(--fg))] placeholder:text-[rgb(var(--muted))] focus:border-[rgb(var(--ring))] focus:outline-none focus:ring-2 focus:ring-[rgb(var(--ring))]"
            />
            <p className="mt-1 text-xs text-[rgb(var(--muted))]">
              Separar múltiples emails con coma
            </p>
          </div>

          <div>
            <label
              htmlFor="whatsapp-general"
              className="mb-1.5 block text-sm font-medium text-[rgb(var(--fg))]"
            >
              WhatsApp
            </label>
            <input
              id="whatsapp-general"
              type="tel"
              value={destinosGenerales.whatsapp}
              onChange={(e) => handleDestinosGeneralesChange('whatsapp', e.target.value)}
              placeholder="+54 9 11 1234-5678"
              className="h-10 w-full rounded-lg border border-[rgba(var(--border),0.6)] bg-[rgb(var(--subpanel))] px-3 text-sm text-[rgb(var(--fg))] placeholder:text-[rgb(var(--muted))] focus:border-[rgb(var(--ring))] focus:outline-none focus:ring-2 focus:ring-[rgb(var(--ring))]"
            />
          </div>
        </div>

        <div className="mt-4 flex items-start gap-2">
          <input
            id="aplicar-todos"
            type="checkbox"
            checked={aplicarATodos}
            onChange={(e) => handleAplicarATodosChange(e.target.checked)}
            className="mt-0.5 h-4 w-4 rounded border-[rgba(var(--border),0.6)] bg-[rgb(var(--subpanel))] text-[rgb(var(--ring))] focus:ring-2 focus:ring-[rgb(var(--ring))] focus:ring-offset-0"
          />
          <label htmlFor="aplicar-todos" className="cursor-pointer text-sm text-[rgb(var(--fg))]">
            Aplicar estos destinos a todos los avisos
          </label>
        </div>
      </section>

      <section className="rounded-xl border border-[rgba(var(--border),0.6)] bg-[rgb(var(--panel))] p-6">
        <h3 className="mb-4 text-base font-semibold text-[rgb(var(--fg))]">
          Restricciones de envío
        </h3>

        <div className="flex items-start gap-2">
          <input
            id="no-enviar-fuera-horario"
            type="checkbox"
            checked={noEnviarFueraHorario}
            onChange={(e) => handleNoEnviarFueraHorario(e.target.checked)}
            className="mt-0.5 h-4 w-4 rounded border-[rgba(var(--border),0.6)] bg-[rgb(var(--subpanel))] text-[rgb(var(--ring))] focus:ring-2 focus:ring-[rgb(var(--ring))] focus:ring-offset-0"
          />
          <label htmlFor="no-enviar-fuera-horario" className="text-sm text-[rgb(var(--fg))]">
            No enviar notificaciones fuera de horario permitido
          </label>
        </div>

        {noEnviarFueraHorario ? (
          <div className="mt-4 grid gap-4 md:grid-cols-2">
            <div>
              <label className="mb-1.5 block text-sm font-medium text-[rgb(var(--fg))]">
                Horario desde
              </label>
              <input
                type="time"
                value={horarioDesde}
                onChange={(e) => handleHorarioChange('horarioDesde', e.target.value)}
                className="h-10 w-full rounded-lg border border-[rgba(var(--border),0.6)] bg-[rgb(var(--subpanel))] px-3 text-sm text-[rgb(var(--fg))]"
              />
            </div>

            <div>
              <label className="mb-1.5 block text-sm font-medium text-[rgb(var(--fg))]">
                Horario hasta
              </label>
              <input
                type="time"
                value={horarioHasta}
                onChange={(e) => handleHorarioChange('horarioHasta', e.target.value)}
                className="h-10 w-full rounded-lg border border-[rgba(var(--border),0.6)] bg-[rgb(var(--subpanel))] px-3 text-sm text-[rgb(var(--fg))]"
              />
            </div>
          </div>
        ) : null}
      </section>

      {/* Avisos por Estado */}
      <section className="rounded-xl border border-[rgba(var(--border),0.6)] bg-[rgb(var(--panel))] p-6">
        <h3 className="mb-4 text-base font-semibold text-[rgb(var(--fg))]">
          Avisos por Estado
        </h3>

        <div className="mb-3 rounded-lg bg-[rgb(var(--subpanel))] p-3">
          <p className="text-xs text-[rgb(var(--muted))]">
            <svg
              className="mb-1 mr-1 inline-block h-4 w-4"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
              />
            </svg>
            Active los canales de notificación por cada evento. Los destinos personalizados son opcionales; 
            si no se especifican, se utilizarán los destinos generales configurados arriba.
          </p>
        </div>

        <div className="overflow-x-auto">
          <table className="w-full text-sm">
            <thead>
              <tr className="border-b border-[rgba(var(--border),0.4)]">
                <th className="pb-3 text-left font-semibold text-[rgb(var(--fg))]">Evento</th>
                <th className="pb-3 text-center font-semibold text-[rgb(var(--fg))]">Email</th>
                <th className="pb-3 text-center font-semibold text-[rgb(var(--fg))]">WhatsApp</th>
                <th className="pb-3 text-left font-semibold text-[rgb(var(--fg))]">Destinos Personalizados</th>
              </tr>
            </thead>
            <tbody>
              {ESTADOS_ENVIO.map((estado) => {
                const isEmailChecked = avisosPorEstado[estado.id]?.email || false;
                const isWhatsappChecked = avisosPorEstado[estado.id]?.whatsapp || false;
                
                return (
                  <tr
                    key={estado.id}
                    className={clsx(
                      'border-b border-[rgba(var(--border),0.2)]',
                      estado.warning && 'bg-[rgba(255,193,7,0.05)]'
                    )}
                  >
                    <td className="py-3">
                      <div className="flex items-center gap-2">
                        {estado.warning && (
                          <svg
                            className="h-4 w-4 text-yellow-500"
                            fill="currentColor"
                            viewBox="0 0 20 20"
                          >
                            <path
                              fillRule="evenodd"
                              d="M8.257 3.099c.765-1.36 2.722-1.36 3.486 0l5.58 9.92c.75 1.334-.213 2.98-1.742 2.98H4.42c-1.53 0-2.493-1.646-1.743-2.98l5.58-9.92zM11 13a1 1 0 11-2 0 1 1 0 012 0zm-1-8a1 1 0 00-1 1v3a1 1 0 002 0V6a1 1 0 00-1-1z"
                              clipRule="evenodd"
                            />
                          </svg>
                        )}
                        <span className={clsx('font-medium', estado.warning && 'text-yellow-600')}>
                          {estado.label}
                        </span>
                      </div>
                    </td>
                    <td className="py-3 text-center">
                      <input
                        type="checkbox"
                        checked={isEmailChecked}
                        onChange={(e) => handleAvisoChange(estado.id, 'email', e.target.checked)}
                        className="h-4 w-4 rounded border-[rgba(var(--border),0.6)] bg-[rgb(var(--subpanel))] text-[rgb(var(--ring))] focus:ring-2 focus:ring-[rgb(var(--ring))] focus:ring-offset-0"
                      />
                    </td>
                    <td className="py-3 text-center">
                      <input
                        type="checkbox"
                        checked={isWhatsappChecked}
                        onChange={(e) => handleAvisoChange(estado.id, 'whatsapp', e.target.checked)}
                        className="h-4 w-4 rounded border-[rgba(var(--border),0.6)] bg-[rgb(var(--subpanel))] text-[rgb(var(--ring))] focus:ring-2 focus:ring-[rgb(var(--ring))] focus:ring-offset-0"
                      />
                    </td>
                    <td className="py-3">
                      <div className="space-y-2">
                        {/* Input de Email personalizado - solo visible si está tildado Email */}
                        {isEmailChecked && (
                          <div>
                            <label className="mb-1 block text-xs text-[rgb(var(--muted))]">
                              Email personalizado (opcional)
                            </label>
                            <input
                              type="email"
                              value={avisosPorEstado[estado.id]?.destinoPersonalizado || ''}
                              onChange={(e) => handleAvisoChange(estado.id, 'destinoPersonalizado', e.target.value)}
                              placeholder={destinosGenerales.emails || "email@ejemplo.com"}
                              className="h-8 w-full rounded-lg border border-[rgba(var(--border),0.6)] bg-[rgb(var(--subpanel))] px-2 text-xs text-[rgb(var(--fg))] placeholder:text-[rgb(var(--muted))] focus:border-[rgb(var(--ring))] focus:outline-none focus:ring-1 focus:ring-[rgb(var(--ring))]"
                            />
                          </div>
                        )}
                        
                        {/* Input de WhatsApp personalizado - solo visible si está tildado WhatsApp */}
                        {isWhatsappChecked && (
                          <div>
                            <label className="mb-1 block text-xs text-[rgb(var(--muted))]">
                              WhatsApp personalizado (opcional)
                            </label>
                            <input
                              type="tel"
                              value={avisosPorEstado[estado.id]?.whatsappPersonalizado || ''}
                              onChange={(e) => handleAvisoChange(estado.id, 'whatsappPersonalizado', e.target.value)}
                              placeholder={destinosGenerales.whatsapp || "+54 9 11 1234-5678"}
                              className="h-8 w-full rounded-lg border border-[rgba(var(--border),0.6)] bg-[rgb(var(--subpanel))] px-2 text-xs text-[rgb(var(--fg))] placeholder:text-[rgb(var(--muted))] focus:border-[rgb(var(--ring))] focus:outline-none focus:ring-1 focus:ring-[rgb(var(--ring))]"
                            />
                          </div>
                        )}
                        
                        {/* Mensaje cuando no hay ninguno seleccionado */}
                        {!isEmailChecked && !isWhatsappChecked && (
                          <p className="text-xs italic text-[rgba(var(--muted),0.7)]">
                            Sin notificaciones configuradas
                          </p>
                        )}
                      </div>
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      </section>
    </div>
  );
}
